import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import AuthLayout from '../../components/AuthLayout';
import Logo from '../../assets/images/logo.png';
import UserIcon from '../../components/icons/UserIcon';
import LockIcon from '../../components/icons/LockIcon';
import EnvelopeIcon from '../../components/icons/EnvelopeIcon';
import envelopeImg from '../../assets/images/envelope.svg';
import { useAuth } from '../../contexts/AuthContext';

const Signup = () => {
  const { signup } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  const [userDataError, setUserDataError] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  const history = useHistory();

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const validateInput = (value, name) => {
    if (!value) {
      setUserDataError((userDataError) => ({
        ...userDataError,
        [name]: 'This field should not be empty.',
      }));
      return false;
    }

    switch (name) {
      case 'email':
        const emailValid = validateEmail(value);
        if (!emailValid) {
          setUserDataError((userDataError) => ({
            ...userDataError,
            [name]: 'Invalid e-mail address',
          }));
          return false;
        } else {
          setUserDataError((userDataError) => ({ ...userDataError, [name]: '' }));
          return true;
        }
      case 'password':
        if (user['confirmPassword'] !== value) {
          setUserDataError((userDataError) => ({
            ...userDataError,
            confirmPassword: `Passwords don't match.`,
            password: `Passwords don't match.`,
          }));
          return false;
        } else {
          setUserDataError((userDataError) => ({
            ...userDataError,
            confirmPassword: '',
            password: '',
          }));
          return true;
        }
      case 'confirmPassword':
        if (user['password'] !== value) {
          setUserDataError((userDataError) => ({
            ...userDataError,
            confirmPassword: `Passwords don't match.`,
            password: `Passwords don't match.`,
          }));
          return false;
        } else {
          setUserDataError((userDataError) => ({
            ...userDataError,
            confirmPassword: '',
            password: '',
          }));
          return true;
        }
      default:
        setUserDataError((userDataError) => ({ ...userDataError, [name]: '' }));
        return true;
    }
  };

  const handleChange = (e) => {
    validateInput(e.target.value, e.target.name);
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleSignup = () => {
    setError('');
    setLoading(true);

    const result = Object.keys(user).map((key) => {
      return validateInput(user[key], key);
    });

    const isInvalid = result.filter((r) => !r).length > 0;

    if (isInvalid) {
      return;
    }

    signup(user.email, user.password, user.firstName, user.lastName)
      .then((ref) => {
        setLoading(false);
        history.push('/');
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  return (
    <AuthLayout>
      <div className="auth-signup">
        <div className="auth-container">
          <div className="half-section">
            <div className="auth-text">
              <img src={Logo} alt="" className="logo" />
              <h1>
                Hello, Welcome to <span>We All Count’s</span> Funding Web tool.
              </h1>
              <p>You can find a short introduction to the tool here.</p>
              <div className="text-block">
                <span>
                  We will collect your email address only so that you can save your Funding Webs for
                  your future use and so that you can recover/reset your password.
                </span>
              </div>
              <div className="text-block">
                <span>
                  The email will not be used for any other purposes, including marketing or
                  promotion.
                </span>
              </div>
              <div className="text-block">
                <span>
                  If you would like to contact us directly or be added to our newsletter list,
                  please send an email to hello@weallcount.com
                </span>
              </div>
            </div>
          </div>
          <div className="half-section">
            <div className="auth-card">
              <h2>Register a New account</h2>
              <div className="auth-form-group">
                <div>
                  <div className={`auth-form ${userDataError.firstName ? 'error' : ''}`}>
                    <div className="main-image">
                      <UserIcon color={userDataError.firstName ? '#F98784' : '#594FD1'} />
                    </div>
                    <div className="main-input">
                      <label htmlFor="first_name">First Name</label>
                      <input
                        type="text"
                        placeholder="First Name"
                        id="first_name"
                        name="firstName"
                        value={user.firstName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  {userDataError.firstName && (
                    <p className="error-msg">{userDataError.firstName}</p>
                  )}
                </div>
                <div>
                  <div className={`auth-form ${userDataError.lastName ? 'error' : ''}`}>
                    <div className="main-image">
                      <UserIcon color={userDataError.lastName ? '#F98784' : '#594FD1'} />
                    </div>
                    <div className="main-input">
                      <label htmlFor="first_name">Last Name</label>
                      <input
                        type="text"
                        placeholder="Last Name"
                        id="last_name"
                        name="lastName"
                        value={user.lastName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  {userDataError.lastName && <p className="error-msg">{userDataError.lastName}</p>}
                </div>
              </div>
              <div className={`auth-form ${userDataError.email ? 'error' : ''}`}>
                <div className="main-image">
                  <EnvelopeIcon color={userDataError.email ? '#F98784' : '#594FD1'} />
                </div>
                <div className="main-input">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={user.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {userDataError.email && <p className="error-msg">{userDataError.email}</p>}
              <div className={`auth-form ${userDataError.password ? 'error' : ''}`}>
                <div className="main-image">
                  <LockIcon color={userDataError.password ? '#F98784' : '#594FD1'} />
                </div>
                <div className="main-input">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    placeholder="Password"
                    name="password"
                    value={user.password}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {userDataError.password && <p className="error-msg">{userDataError.password}</p>}
              <div className={`auth-form ${userDataError.confirmPassword ? 'error' : ''}`}>
                <div className="main-image">
                  <LockIcon color={userDataError.confirmPassword ? '#F98784' : '#594FD1'} />
                </div>
                <div className="main-input">
                  <label htmlFor="confirm_password">Confirm Password</label>
                  <input
                    type="password"
                    placeholder="Confirm Password"
                    id="confirm_password"
                    name="confirmPassword"
                    value={user.confirmPassword}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {userDataError.confirmPassword && (
                <p className="error-msg">{userDataError.confirmPassword}</p>
              )}
              {error && <p className="error-msg">{error}</p>}
              <div className="actions">
                <button className="primary-btn" onClick={() => handleSignup()}>
                  Register
                </button>
              </div>
              <p className="question-text">Already have an account?</p>
              <div className="text-center">
                <Link to="/" className="link">
                  Click here to Log in
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Signup;
